(() => {
  'use strict';
  if (window.__NH2_VARIANT_RUNTIME__) return;
  window.__NH2_VARIANT_RUNTIME__ = true;

  const root = document.querySelector('[data-nh2-product-root]');
  const select = root?.querySelector('#nh2-variant-select');
  const marker = root?.querySelector('[data-nh2-current-product]');
  if (!root || !select || !marker?.dataset.nh2Handle) return;

  const launchReady = marker.dataset.nh2LaunchReady === 'true';
  const priceBox = root.querySelector('.nh2-price');
  const stockBox = root.querySelector('.nh2-stock');
  const stockText = stockBox?.querySelector('span:last-child');
  const addButton = root.querySelector('#nh2-product-form .nh2-add');
  const decisionButtons = root.querySelectorAll('[data-nh2-save], [data-nh2-compare]');
  let productPromise;

  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(value); }
    catch (_) { return `${value.toFixed(2)} zł`; }
  };

  const loadProduct = () => {
    if (!productPromise) {
      productPromise = fetch(`/products/${encodeURIComponent(marker.dataset.nh2Handle)}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then((response) => {
        if (!response.ok) throw new Error(`Product JSON ${response.status}`);
        return response.json();
      }).catch(() => null);
    }
    return productPromise;
  };

  const updatePrice = (variant) => {
    if (!priceBox) return;
    let current = priceBox.querySelector('span');
    if (!current) {
      current = document.createElement('span');
      priceBox.prepend(current);
    }
    const formatted = money(variant.price);
    current.textContent = formatted;

    let compare = priceBox.querySelector('s');
    if (Number(variant.compare_at_price || 0) > Number(variant.price || 0)) {
      if (!compare) {
        compare = document.createElement('s');
        priceBox.appendChild(compare);
      }
      compare.textContent = money(variant.compare_at_price);
    } else if (compare) {
      compare.remove();
    }

    marker.dataset.nh2Price = formatted;
    decisionButtons.forEach((button) => { button.dataset.nh2Price = formatted; });
  };

  const updateStock = (variant) => {
    if (stockBox) {
      stockBox.classList.toggle('is-review', !launchReady);
      stockBox.classList.toggle('is-out', launchReady && !variant.available);
    }
    if (stockText) {
      stockText.textContent = !launchReady
        ? 'Produkt w weryfikacji przed sprzedażą online'
        : variant.available
          ? 'Dostępny do zamówienia'
          : 'Aktualnie niedostępny';
    }
    if (addButton) {
      const canBuy = launchReady && variant.available;
      addButton.disabled = !canBuy;
      addButton.setAttribute('aria-disabled', canBuy ? 'false' : 'true');
      addButton.textContent = canBuy ? 'Dodaj do koszyka' : !launchReady ? 'Weryfikacja produktu' : 'Produkt niedostępny';
    }
  };

  const updateSku = (variant) => {
    root.querySelectorAll('.nh2-specs tr').forEach((row) => {
      if (row.querySelector('th')?.textContent?.trim() !== 'SKU') return;
      const cell = row.querySelector('td');
      if (cell) cell.textContent = variant.sku || '—';
    });
  };

  const updateUrl = (variant) => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', url);
    } catch (_) {}
  };

  const render = (variant) => {
    if (!variant) return;
    updatePrice(variant);
    updateStock(variant);
    updateSku(variant);
    updateUrl(variant);
    document.dispatchEvent(new CustomEvent('nh2:variant-change', { detail: { variant } }));
  };

  const sync = async () => {
    const product = await loadProduct();
    if (!product?.variants) return;
    const variant = product.variants.find((entry) => String(entry.id) === String(select.value));
    render(variant);
  };

  select.addEventListener('change', sync);
  sync();
})();
